<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">
      <div class="card-body padding-top-0px margin-left-0px padding-right-0px padding-left-0px padding-bottom-0px">

        <div class="modal-body padding-top-0px padding-right-0px padding-left-0px padding-bottom-0px">

          <!--<div class="card-header wh-header padding-bottom-0px border-bottom-1px" *ngIf="Categories">

            Add New Patient

            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>-->
          <!--<div class="card-header wh-header padding-bottom-0px border-bottom-1px" *ngIf="Individual">

            Add New Patient

            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>-->

          <form class="form" novalidate="" #f="ngForm">
            <div class="card">
              <div class="card-header wh-header padding-bottom-0px border-bottom-1px">

                Partner Details
                <button type="button" class="close" data-dismiss="modal"
                        (click)="activeModal.dismiss('Cross click')"
                        aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="card-body margin-left-0px padding-top-0px">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-4 border-rt padding-left-0px">
                      <div class="card">
                        <div class="card-header wh-header color-female-heading padding-right-0px ">
                          Female Details
                        </div>

                      </div>


                    </div>
                    <!--<label>Male</label>-->
                    <div class="col-md-4 padding-left-0px">
                      <div class="card">
                        <div class="card-header wh-header color-male-heading">
                          Male Details
                        </div>

                      </div>

                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <div class="card">
                        <div class="card-body padding-all-0px margin-left-0px">

                          <div class="row">
                            <div class="col-md-12 text-align-right form-group margin-bottom-0px">
                              <label for="firstName" class="margin-bottom-0px margin-top-5px">
                                Salutation (Name Prefix) :


                              </label>
                            </div>



                          </div>


                          <div class="row">
                            <div class="col-md-12 text-align-right form-group margin-bottom-0px">
                              <label for="firstName" class="label-size margin-bottom-0px margin-top-5px">Name :</label>
                            </div>


                          </div>


                          <div class="row">
                            <div class="col-md-12 text-align-right form-group margin-bottom-0px">
                              <label for="birthDate" class="label-size margin-bottom-0px margin-top-5px">Date of Birth :</label>
                            </div>



                          </div>


                          <div class="row">
                            <div class="col-md-12 text-align-right form-group margin-bottom-0px">
                              <label for="birthDate" class="label-size margin-bottom-0px margin-top-5px">Contact Number :</label>
                            </div>



                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card">
                        <div class="card-body padding-all-0px margin-left-0px">

                          <div class="row">

                            <div class="col-md-12 text-align-left" *ngIf="PatientDetailsData">

                              <label class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold">{{PatientDetailsData.FPrefix}}</label>


                            </div>


                          </div>


                          <div class="row">
                            <div class="col-md-12 text-align-left" *ngIf="PatientDetailsData">
                              <label class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold">{{PatientDetailsData.FDisplayName}}</label>
                            </div>


                          </div>


                          <div class="row">
                            <div class="col-md-12 text-align-left" *ngIf="PatientDetailsData">
                              <label class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold">{{PatientDetailsData.FDateOfBirth |date:'dd-MMM-yyy'}}</label>
                            </div>



                          </div>


                          <div class="row">
                            <div class="col-md-12 text-align-left" *ngIf="PatientDetailsData">
                              <label for="diaplayName" class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold">{{PatientDetailsData.FTelephone1}}</label>
                            </div>



                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="card">
                        <div class="card-body padding-all-0px margin-left-0px">

                          <div class="row">

                            <div class="col-md-12 text-align-left" *ngIf="PatientDetailsData">
                              <label for="diaplayName" class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold">{{PatientDetailsData.MPrefix}}</label>
                            </div>


                          </div>



                          <div class="row">
                            <div class="col-md-12 text-align-left" *ngIf="PatientDetailsData">
                              <label for="diaplayName" class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold">{{PatientDetailsData.MDisplayName}}</label>
                            </div>


                          </div>


                          <div class="row">
                            <div class="col-md-12 text-align-left" *ngIf="PatientDetailsData">
                              <label for="diaplayName" class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold">{{PatientDetailsData.MDateOfBirth |date:'dd-MMM-yyy'}}</label>
                            </div>



                          </div>

                          <div class="row">
                            <div class="col-md-12 text-align-left" *ngIf="PatientDetailsData">
                              <label for="diaplayName" class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold">{{PatientDetailsData.MTelephone1}}</label>
                            </div>



                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3 text-align-right form-group margin-bottom-0px">
                      <label for="diaplayName" class="label-size margin-bottom-0px margin-top-0px">Address :</label>
                    </div>
                    <div class="col-md-8" *ngIf="PatientDetailsData">
                      <div class="row">
                        <div class="col-md-12 col-12 padding-right-0px">
                          <label for="diaplayName" class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold">{{PatientDetailsData.AddressLine1}} {{PatientDetailsData.City}} {{PatientDetailsData.State}}</label>
                        </div>
                      </div>
                      <!--<div class="row">
                        <div class="col-md-12 col-12 padding-right-0px">
                          <label for="diaplayName" class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold">{{PatientDetailsData.City}}, {{PatientDetailsData.State}}</label>
                        </div>
                      </div>-->
                      <!--<div class="row">
                        <div class="col-md-12 col-12 padding-right-0px">
                          <label for="diaplayName" class="margin-bottom-0px margin-top-3px color-Assign font-weight-bold"> {{PatientDetailsData.ZipCode}}, {{PatientDetailsData.State}}, {{PatientDetailsData.County}}</label>
                        </div>
                      </div>-->
                    </div>
                  </div>


                  <div class="row">
                    <div class=" col-md-3 text-align-right form-group margin-bottom-0px">
                      <label for="diaplayName" class="label-size margin-bottom-0px margin-top-5px">Wedding Anniversary :</label>
                    </div>
                    <div class="col-md-3" *ngIf="PatientDetailsData">
                      <label for="diaplayName" class="margin-bottom-0px margin-top-5px color-Assign font-weight-bold">{{PatientDetailsData.MarriageDate |date:'dd-MMM-yyy'}}</label>
                    </div>
                  </div>

                </div>

              </div>

            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
</div>

